<vb-theme-styles></vb-theme-styles>

<div class="height-full" ui-view></div>
